import { Row } from 'antd';
import DatePicker, { calendarDatePickerRef } from './DatePicker';
import SettingConfigs from './SettingConfigs';
import styled from 'styled-components';
import Box from 'components/Box';
import AppointmentHint from './AppointmentHint';
import CustomerSearch from './CustomerSearch';
import CallerIdHistory from './CallerIdHistory';
import StaffPaging from './StaffPaging';
import StaffBookingSort from './StaffBookingSort';
import { calendarSelectors } from 'services/selectors/apt';

type Props = {
  enablePaging?: boolean;
};
const CalendarFilter = ({ enablePaging }: Props) => {
  // FULL_SCREEN an ca hang `CalendarFilterStyled` bang CSS, keo theo o chon ngay. Chuyen han
  // DatePicker xuong hang duoi thay vi render them mot cai thu hai — hai instance se tranh
  // nhau `calendarDatePickerRef` va saga chi dieu khien duoc cai mount sau cung.
  const fullScreen = calendarSelectors.fullScreen();

  return (
    <Container display='flex' flexDirection='column' alignSelf='stretch'>
      <CalendarFilterStyled className='CalendarFilterStyled' justify={'space-between'}>
        {!fullScreen && <DatePicker ref={calendarDatePickerRef} />}
        <SettingConfigs />
      </CalendarFilterStyled>
      <Box display='flex' alignItems='center' alignSelf='stretch' gap='2' px='4' mt='1'>
        {fullScreen && <DatePicker ref={calendarDatePickerRef} compact />}
        <CustomerSearch />
        <StaffBookingSort />
        <AppointmentHint />
        <CallerIdHistory />
        {enablePaging && <StaffPaging />}
      </Box>
    </Container>
  );
};

export default CalendarFilter;
const Container = styled(Box)`
  zoom: 0.8;
`;
const CalendarFilterStyled = styled(Row)`
  padding: 0 1.5rem;
  background: #EAEDED;
  position: relative;
`;
